import { Box, Grid, Heading, Stat, StatLabel, StatNumber, Skeleton } from '@chakra-ui/react'
import { Smartphone } from 'lucide-react'

type Props = {
  online: number
  idle: number
  offline: number
  total: number
  isLoading?: boolean
}

export function DeviceHealthWidget({ online, idle, offline, total, isLoading }: Props) {
  if (isLoading) {
    return <Skeleton height="120px" borderRadius="md" />
  }

  return (
    <Box bg="white" borderRadius="md" boxShadow="sm" p={4}>
      <Heading size="sm" mb={3} display="flex" alignItems="center" gap={2}>
        <Smartphone size={18} />
        Mobile Device Health
      </Heading>
      <Grid templateColumns="repeat(4, 1fr)" gap={3}>
        <Stat size="sm"><StatLabel>Online</StatLabel><StatNumber color="green.500">{online}</StatNumber></Stat>
        <Stat size="sm"><StatLabel>Idle</StatLabel><StatNumber color="gray.500">{idle}</StatNumber></Stat>
        <Stat size="sm"><StatLabel>Offline</StatLabel><StatNumber color="orange.500">{offline}</StatNumber></Stat>
        <Stat size="sm"><StatLabel>Total</StatLabel><StatNumber>{total}</StatNumber></Stat>
      </Grid>
    </Box>
  )
}
